export default {
  reports: 'Reporty',
  components: 'Komponenty',
};
